<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center  pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              type="outline-neutral"
              class="min-button ml-2 no-mb"
              @click="mode = 'view'"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button no-mb ml-2"
              v-if="mode === 'view'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>
            <base-button
              type="primary"
              class="min-button  no-mb ml-2"
              @click="saveCustomer()"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row justify-content-center">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Payment Info</h2>

                <div class="data-block" v-if="mode === 'view'">
                  <span class="title-block">{{
                    getTypeMarkup(type_markup)
                  }}</span>
                  <span class="content-block" v-if="customer.mark_up"
                    >{{ customer.mark_up }}%</span
                  >
                  <span class="content-block" v-else>0</span>
                </div>

                <div class="row align-items-center" v-if="mode === 'edit'">
                  <div
                    class="col-xl-12 col-lg-6 col-md-6 col-sm-3 col-12 switch-xl "
                  >
                    <label class="title-label-np">Terms</label>
                    <base-switch
                      onText="Markup"
                      offText="Discount"
                      v-model="type_markup"
                    ></base-switch>
                  </div>

                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                    <BaseNumberInput
                      v-model.number="$v.customer.mark_up.$model"
                      label="Value"
                      placeholder="Value"
                      id="customer_markup"
                      name="customer_markup"
                      class="input-append"
                      @input="validateMarkup"
                      :error="
                        !$v.customer.mark_up.between
                          ? `Must be between ${$v.customer.mark_up.$params.between.min} and ${$v.customer.mark_up.$params.between.max}`
                          : ''
                      "
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card ">
                <h2 class="subtitle">Notes</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="data-block" v-if="mode === 'view'">
                      <span class="content-block" v-if="customer.notes">{{
                        customer.notes
                      }}</span>
                      <span class="content-block" v-else>No notes here</span>
                    </div>

                    <div class="mb-4" v-if="mode === 'edit'">
                      <el-input
                        v-model="$v.customer.notes.$model"
                        placeholder="Special Requirements"
                        id="customer_notes"
                        name="customer_notes"
                        tabindex="23"
                        maxlength="200"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 5 }"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-12 col-md-12">
          <div class="card pb-4" v-if="mode === 'edit'">
            <h2 class="subtitle">Customer Type</h2>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
                <div
                  class="option-transfers d-xl-block d-lg-block d-md-block d-sm-block d-none"
                >
                  <b-form-radio-group
                    id="btn-radios-1"
                    v-model="type"
                    :options="typeOptions"
                    name="radios-btn-default"
                    buttons
                    @change="changeTypeCustomer"
                    value-field="value"
                    text-field="label"
                    button-variant="group-neutral"
                    tabindex="1"
                    class="buttons-type"
                  ></b-form-radio-group>
                </div>

                <div
                  class="d-xl-none d-lg-none d-md-none d-sm-none d-block mt-2"
                >
                  <WSelect
                    id="typeCustomer"
                    name="typeCustomer"
                    placeholder="Type"
                    v-model="type"
                    label="Type"
                    class="mb-0"
                  >
                    <el-option
                      v-for="option in typeOptions"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </WSelect>
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-if="type === 'business'">
            <h2 class="subtitle">
              Business Details
            </h2>

            <div class="col-12" v-if="mode === 'view'">
              <div class="row">
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="data-block">
                    <span class="title-block">Business Name</span>
                    <span class="content-block">{{
                      customer.company_name
                    }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.vat_number"
                >
                  <div class="data-block">
                    <span class="title-block">VAT Number</span>
                    <span class="content-block">{{ customer.vat_number }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.reg_number"
                >
                  <div class="data-block">
                    <span class="title-block">Reg. Number</span>
                    <span class="content-block">{{ customer.reg_number }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="mode === 'edit'">
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                v-if="type === 'business'"
              >
                <base-input
                  v-model.trim="$v.customer.company_name.$model"
                  label="Business Name"
                  placeholder="Business Name"
                  id="bussiness_name"
                  name="bussiness_name"
                  markrequired
                  :error="
                    !$v.customer.company_name.minLength ||
                    $v.customer.company_name.$error
                      ? `Enter from ${$v.customer.company_name.$params.minLength.min} letters.`
                      : ''
                  "
                />
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"
                v-if="type === 'business'"
              >
                <base-input
                  v-model.trim="$v.customer.vat_number.$model"
                  label="VAT Number"
                  placeholder="VAT Number"
                  id="bussiness_VatNumber"
                  name="bussiness_VatNumber"
                  :error="
                    !$v.customer.vat_number.minLength
                      ? `Enter from ${$v.customer.vat_number.$params.minLength.min} characters.`
                      : ''
                  "
                />
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"
                v-if="type === 'business'"
              >
                <base-input
                  v-model.trim="$v.customer.reg_number.$model"
                  label="Reg. Number"
                  placeholder="Reg. Number"
                  id="bussiness_regNumber"
                  name="bussiness_regNumber"
                  :error="
                    !$v.customer.reg_number.minLength
                      ? `Enter from ${$v.customer.reg_number.$params.minLength.min} characters.`
                      : ''
                  "
                />
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle">
              Main Contact
            </h2>
            <div v-if="mode === 'view'">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Full Name</span>
                      <span class="content-block capitalize "
                        >{{ customer.first_name }}
                        {{ customer.last_name }}</span
                      >
                    </div>
                  </div>
                  <div
                    class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="customer.gender"
                  >
                    <div class="data-block">
                      <span class="title-block">Gender</span>
                      <span class="content-block">{{
                        getGender(customer.gender)
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="customer.date_of_birth"
                  >
                    <div class="data-block">
                      <span class="title-block">Date of Birth</span>
                      <span class="content-block">{{
                        customer.date_of_birth
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="customer.goverment_id"
                  >
                    <div class="data-block">
                      <span class="title-block">Goverment ID</span>
                      <span class="content-block">{{
                        customer.goverment_id
                      }}</span>
                    </div>
                  </div>

                  <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Email Address</span>
                      <span class="content-block">
                        <a
                          :href="
                            `https://mail.google.com/mail/?view=cm&fs=1&to=${customer.email}`
                          "
                          target="_blank"
                          >{{ customer.email }}</a
                        >
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="customer.email"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Contact Number</span>
                      <span class="content-block">
                        <a :href="`tel:${customer.phone}`">{{
                          customer.phone
                        }}</a>
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="customer.phone"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="customer.other_contact_platform"
                  >
                    <div class="data-block">
                      <span class="title-block">Other Contact Info</span>
                      <span class="content-block">
                        <i
                          class="flaticon-bold-whatsapp f16 mr-1"
                          v-if="customer.other_contact_platform === 'Whatsapp'"
                        ></i>
                        <i
                          class="flaticon-bold-logotipo-de-skype f16 mr-1"
                          v-if="customer.other_contact_platform === 'Skype'"
                        ></i>

                        {{ customer.other_contact_platform }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="mode === 'edit'">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  id="first_name"
                  name="first_name"
                  v-model.trim="$v.customer.first_name.$model"
                  label="First Name"
                  placeholder="First Name"
                  maxlength="45"
                  format="capitalize"
                  markrequired
                  :error="
                    !$v.customer.first_name.minLength ||
                    $v.customer.first_name.$error
                      ? `Enter from ${$v.customer.first_name.$params.minLength.min} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  id="last_name"
                  name="last_name"
                  v-model.trim="$v.customer.last_name.$model"
                  label="Last Name"
                  placeholder="Last Name"
                  maxlength="45"
                  format="capitalize"
                  markrequired
                  :error="
                    !$v.customer.last_name.minLength ||
                    $v.customer.last_name.$error
                      ? `Enter from ${$v.customer.last_name.$params.minLength.min} letters.`
                      : ''
                  "
                />
              </div>

              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 form-group"
                v-bind:class="{
                  'is-invalid': $v.customer.gender.$error
                }"
              >
                <label for="title" class="title-label">Gender</label>

                <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                  <b-form-radio-group
                    v-model="$v.customer.gender.$model"
                    :aria-describedby="ariaDescribedby"
                    id="radio-gender"
                    name="radio-gender"
                    buttons
                    button-variant="outline-neutral"
                    size="md"
                    tabindex="3"
                  >
                    <b-form-radio value="male" class="pc-4" tabindex="3"
                      >Mr.</b-form-radio
                    >
                    <b-form-radio value="female" class="pc-4"
                      >Mrs.</b-form-radio
                    >
                    <b-form-radio value="other" class="pc-4">Mx.</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>

                <small class="invalid-feedback" v-if="$v.customer.gender.$error"
                  >Select</small
                >
              </div>

              <div
                class="col-xl-3 col-lg-4 col-md-3 col-sm-4 col-12"
                v-if="type === 'customer'"
              >
                <base-input label="Date of Birth">
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur"
                    :config="{
                      altFormat: formatDateFlatPicker,
                      altInput: true,
                      dateFormat: 'Y-m-d',
                      allowInput: true
                    }"
                    class="input-custom"
                    v-model="$v.customer.date_of_birth.$model"
                    id="date"
                    name="customer_birth"
                    placeholder="-"
                  ></flat-picker>
                </base-input>
              </div>

              <div
                class="col-xl-6 col-lg-5 col-md-4 col-sm-4 col-12"
                v-if="type === 'customer'"
              >
                <base-input
                  id="goverment_id"
                  name="goverment_id"
                  v-model.trim="$v.customer.goverment_id.$model"
                  label="Goverment ID"
                  placeholder="Goverment ID"
                  :error="
                    !$v.customer.goverment_id.minLength
                      ? `Enter from ${$v.customer.goverment_id.$params.minLength.min} characters.`
                      : ''
                  "
                />
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-7 col-12">
                <base-input
                  id="customer_email"
                  name="customer_email"
                  v-model.trim="email"
                  label="Email Address"
                  placeholder="Email Address"
                  :error="
                    !$v.customer.email.email ||
                    $v.customer.email.$error ||
                    !emailStatus
                      ? `${messageEmail}`
                      : ''
                  "
                  @input="verifyEmailCustomer"
                  :successMessage="messageEmail"
                  :valid="emailStatus"
                  autocomplete="off"
                  markrequired
                />
              </div>

              <div
                class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
              >
                <label
                  class="title-label"
                  v-bind:class="{
                    'is-invalid': $v.customer.phone.$error
                  }"
                  ><span class="markrequired">*</span>Contact Number</label
                >
                <vue-tel-input
                  v-model="phone_format"
                  key="NumberPhoneCustomer"
                  inputId="NumberPhoneCustomer"
                  name="NumberPhoneCustomer"
                  required
                  mode="international"
                  inputClasses="input no-label no-err"
                  :dynamicPlaceholder="true"
                  :disabledFetchingCountry="true"
                  :validCharactersOnly="true"
                  :wrapperClasses="[
                    $v.customer.phone.$error ? 'is-invalid' : '',
                    'mb-0'
                  ]"
                  @validate="customerPhoneNumber"
                ></vue-tel-input>
                <small class="invalid-feedback" v-if="$v.customer.phone.$error"
                  >Enter a valid Phone Number</small
                >
              </div>

              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                <label class="title-label">Other Contact Info</label>
                <div class="d-flex">
                  <b-form-group
                    v-slot="{ ariaDescribedby2 }"
                    class="d-inline-flex"
                  >
                    <b-form-radio-group
                      v-model="customer.other_contact_platform"
                      :aria-describedby="ariaDescribedby2"
                      id="radio-gender"
                      name="radio-gender"
                      tabindex="7"
                      buttons
                      button-variant="outline-neutral"
                      size="md"
                      @change="focuspickupSign()"
                    >
                      <b-form-radio
                        value="Whatsapp"
                        class="pc-2"
                        title="Whatsapp"
                        tabindex="7"
                        ><i class="flaticon-bold-whatsapp f16"></i
                      ></b-form-radio>
                      <b-form-radio value="Skype" class="pc-2" title="Skype"
                        ><i class="flaticon-bold-logotipo-de-skype f16"></i
                      ></b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>

                  <base-input
                    v-model.trim="customer.contact_info"
                    placeholder="Other Contact Info"
                    id="passengers_phone_optional"
                    name="passengers_phone_optional"
                    tabindex="8"
                    class="d-inline-flex"
                  >
                  </base-input>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle">Address</h2>

            <div class="col-xl-12" v-if="mode === 'view'">
              <div
                class="row"
                v-if="
                  customer.street ||
                    customer.city ||
                    customer.state ||
                    customer.zip_code ||
                    customer.country
                "
              >
                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.street"
                >
                  <div class="data-block">
                    <span class="title-block"
                      >Street address, apartment, suite, etc.:</span
                    >
                    <span class="content-block">{{ customer.street }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.city"
                >
                  <div class="data-block">
                    <span class="title-block">City</span>
                    <span class="content-block capitalize">{{
                      customer.city
                    }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.state"
                >
                  <div class="data-block">
                    <span class="title-block">State/Province/Region</span>
                    <span class="content-block">{{ customer.state }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.zip_code"
                >
                  <div class="data-block">
                    <span class="title-block">Zip/Postal Code</span>
                    <span class="content-block">{{ customer.zip_code }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.country"
                >
                  <div class="data-block">
                    <span class="title-block">Country</span>
                    <span class="content-block">{{ customer.country }}</span>
                  </div>
                </div>
              </div>

              <div class="row" v-else>
                <div class="col-12">
                  <div class="data-block">
                    <span class="content-block">No Provided</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="mode === 'edit'">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  id="customer_street"
                  name="customer_street"
                  label="Street address, apartment, suite, etc."
                  placeholder="Street address, apartment, suite, etc"
                  v-model="$v.customer.street.$model"
                  :error="
                    !$v.customer.street.minLength || $v.customer.street.$error
                      ? `Enter from ${$v.customer.street.$params.minLength.min} and to ${$v.customer.street.$params.maxLength.max} characters.`
                      : ''
                  "
                />
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  id="customer_city"
                  name="customer_city"
                  label="City"
                  placeholder="City"
                  v-model="$v.customer.city.$model"
                  :error="
                    !$v.customer.city.minLength || $v.customer.city.$error
                      ? `Enter from ${$v.customer.city.$params.minLength.min} and to ${$v.customer.city.$params.maxLength.max} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  id="customer_state"
                  name="customer_state"
                  label="State/Province/Region"
                  placeholder="State/Province/Region"
                  v-model="$v.customer.state.$model"
                  :error="
                    !$v.customer.state.minLength || $v.customer.state.$error
                      ? `Enter from ${$v.customer.state.$params.minLength.min} and to ${$v.customer.state.$params.maxLength.max} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                <base-input
                  id="customer_zipcode"
                  name="customer_zipcode"
                  label="Zip/Postal Code"
                  placeholder="Zip/Postal Code"
                  v-model.trim="$v.customer.zip_code.$model"
                  type="text"
                  :error="
                    !$v.customer.zip_code.minLength ||
                    $v.customer.zip_code.$error
                      ? `Enter from ${$v.customer.zip_code.$params.minLength.min} and to ${$v.customer.zip_code.$params.maxLength.max} characters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-5 col-md-5 col-sm-5 col-12">
                <WSelect
                  v-bind:class="{
                    'invalid-feedback': $v.customer.country.$error
                  }"
                  id="customer_country"
                  name="customer_country"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="remoteMethod"
                  :loading="loading"
                  placeholder="Enter a Country"
                  v-model="$v.customer.country.$model"
                  label="Country"
                >
                  <el-option
                    v-for="country in options"
                    :value="country.name"
                    :label="country.name"
                    :key="country.name"
                  ></el-option>
                </WSelect>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapMutations } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  numeric,
  requiredIf,
  decimal,
  between,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import endpoint from "../../Commons/Services/index";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import { Select } from "element-ui";
import localHelper from "../Commons/Helper";
import WSelect from "@/components/Select";
import lodash from "lodash";
import { goBack } from "../../../helpers/commons.helpers";
Select.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditCustomers",
  data() {
    return {
      customer: {
        type: "customer",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        contact_info: "",
        goverment_id: "",
        gender: "other",
        date_of_birth: "",
        country: "",
        city: "",
        state: "",
        zip_code: "",
        street: "",
        notes: "",
        company_name: "",
        type_markup: "markup",
        type_charge: "net_price",
        vat_number: "",
        reg_number: "",
        mark_up: 0,
        vip: false,
        relationship: {
          owner: "",
          type: ""
        },
        source: "rhombuss",
        other_contact_platform: ""
      },
      email: "",
      loading: false,
      options: [],
      flag: "",
      type: "customer",
      phone_format: "",
      genderOptions: [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" }
      ],
      typeOptions: [
        { value: "customer", label: "Customer" },
        { value: "business", label: "Business" }
      ],
      original_user_value: [],
      saved: false,
      messageEmail: "",
      emailStatus: false,
      emailValue: "",
      lastEmail: "",
      contact_platform: [
        { value: "Whatsapp", label: "Whatsapp" },
        { value: "Skype", label: "Skype" }
      ],
      type_markup: true,
      type_charge: false,
      customerId: null,
      mode: "view",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png")
    };
  },
  async created() {
    var bread = [
      {
        text: "Customers",
        to: "/customers"
      },

      {
        text: "Customer Profile",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.customerId = this.$route.params.id;
    await this.getCustomer(this.customerId);
  },
  watch: {
    type_markup: function(newVal, oldVal) {
      if (newVal) {
        this.customer.type_markup = "markup";
      } else {
        this.customer.type_markup = "discount";
      }
    },
    type_charge: {
      handler: function(current, old) {
        if (current) {
          this.customer.type_charge = "commission";
        } else {
          this.customer.type_charge = "net_price";
        }
      },
      deep: true
    }
  },
  methods: {
    async getCustomer(customerId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.customers.services.getCustomerById(
          customerId
        );
        this.setLoad(false);
        let customer = data.data;
        if (data.status) {
          this.type = customer.type;
          this.customer.first_name = customer.first_name;
          this.customer.last_name = customer.last_name;
          this.customer.company_name = customer.company_name;
          this.customer.vat_number = customer.vat_number;
          this.customer.reg_number = customer.reg_number;
          this.customer.email = customer.email;
          this.email = this.customer.email;
          this.lastEmail = this.customer.email;
          this.customer.type_markup = customer.type_markup;
          this.type_markup =
            this.customer.type_markup === "markup" ? true : false;
          this.emailValue = this.customer.email;
          this.customer.phone = customer.phone;
          this.phone_format = `${this.customer.phone}`;
          this.customer.goverment_id = customer.goverment_id;
          this.customer.gender = customer.gender;
          this.customer.date_of_birth = customer.date_of_birth;
          this.customer.country = customer.country;
          this.customer.city = customer.city;
          this.customer.state = customer.state;
          this.customer.zip_code = customer.zip_code;
          this.customer.street = customer.street;
          this.customer.notes = customer.notes;
          this.customer.mark_up = customer.mark_up;
          this.customer.type_charge = customer.type_charge;
          this.type_charge =
            customer.type_charge === "commission" ? true : false;
          this.customer.vip = customer.vip;
          this.customer.type = customer.type;
          this.customer.relationship = Object.assign({}, customer.relationship);
          this.customer.other_contact_platform =
            customer.other_contact_platform;
          this.customer.contact_info = customer.contact_info;
          this.customerCopy = lodash.cloneDeep(this.customer);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error loading the Customer, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error loading the Customer, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async saveCustomer(route = null) {
      try {
        if (
          !this.$v.customer.$invalid &&
          (this.emailStatus || this.emailValue === this.customer.email)
        ) {
          var customer = lodash.cloneDeep(this.customer);
          customer.full_name = `${customer.first_name} ${customer.last_name}`;
          await this.updateCustomer(this.$route.params.id, customer, route);
        } else {
          this.$v.customer.$touch();
          await this.verifyEmailCustomer(this.customer.email);
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error updating the Customer, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateCustomer(customerId, customer, route = null) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.customers.services.updateCustomerById(
          customerId,
          customer
        );
        this.setLoad(false);
        this.saved = true;
        if (data.data !== null) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Customer has been updated",
            icon: "flaticon-check-3"
          });
          this.$router.push(route ? route : "/customers");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error updating the Customer, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error updating the Customer, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    customerPhoneNumber(payload) {
      let result = payload;
      if (result.isValid) {
        this.customer.phone = result.number.e164;
      } else {
        this.customer.phone = "";
      }
    },
    async verifyEmailCustomer(event) {
      try {
        this.customer.email = event.toLowerCase();
        let owner = this.getOwner();
        if (!this.$v.customer.email.$invalid) {
          if (this.lastEmail === this.customer.email) {
            this.emailStatus = true;
            this.messageEmail = "";
          } else {
            let { data } = await endpoint.auth.services.verifyCustomer(
              this.customer.email,
              owner,
              this.sesion.role
            );
            if (data.code === 200 && data.data.status) {
              this.emailStatus = true;
              this.messageEmail = "Email is valid";
            } else {
              this.emailStatus = false;
              this.messageEmail = "Email is invalid or already taken";
            }
          }
        } else {
          this.emailStatus = false;
          this.messageEmail = "Enter a valid email";
        }
      } catch (error) {
        this.messageEmail = "Email is invalid or already taken";
        this.emailStatus = false;
      }
    },
    remoteMethod(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.options = [];
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    validateMarkup(value) {
      if (parseFloat(value) < 0) {
        this.customer.mark_up = 0;
      }
    },
    getOwner() {
      return this.sesion.role === this.sesion.account_type.type
        ? this.sesion.id
        : this.sesion.account_type.owner;
    },
    changeTypeCustomer(type) {
      this.$v.$reset();
      this.customer.type = type;
      if (this.customer.type === "customer") {
        this.customer.company_name = "";
      }
      this.customerCopy = lodash.cloneDeep(this.customer);
    },
    async detectChanges(to, from, next) {
      let isEqual = lodash.isEqual(this.customer, this.customerCopy);
      if (!isEqual && !this.saved) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Customer has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveCustomer(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    getTypeMarkup(type) {
      if (type) {
        return "Markup";
      } else {
        return "Discount";
      }
    },
    getGender(gender) {
      if (gender === "male") {
        return "Male";
      } else if (gender == "female") {
        return "Female";
      } else {
        return "Other";
      }
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The data has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The data couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    ...mapMutations(["setLoad", "setItemsBread", "setCustomersSearchCriteria"])
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInCustomersModule(
      to.meta.modules,
      this.setCustomersSearchCriteria,
      "customers"
    );
    this.detectChanges(to, from, next);
  },
  validations: {
    customer: {
      first_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      last_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      company_name: {
        required: requiredIf(function(value) {
          return ["business", "travel_agency"].indexOf(this.type) > -1;
        }),
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      vat_number: {
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      reg_number: {
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      type_markup: {
        required: true
      },
      mark_up: {
        numeric,
        decimal,
        between: between(0, 100),
        minLength: minLength(1),
        maxLength: maxLength(2)
      },
      email: {
        required,
        email
      },
      goverment_id: {
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      gender: {
        required: requiredIf(function(value) {
          return this.type === "customer";
        })
      },
      phone: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(25)
      },

      country: {
        ValName,
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      city: {
        ValName,
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      state: {
        ValName,
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      zip_code: {
        minLength: minLength(4),
        maxLength: maxLength(10)
      },
      street: {
        minLength: minLength(5),
        maxLength: maxLength(100)
      },
      type: {
        required
      },
      vip: {
        required
      },
      date_of_birth: {
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      notes: {
        maxLength: maxLength(200)
      }
    }
  },
  components: {
    flatPicker,
    VueTelInput,
    WSelect
  },
  computed: {
    ...mapGetters([
      "countries",
      "sesion",
      "load",
      "settings",
      "customersSearchCriteria"
    ]),
    formatDateFlatPicker: function() {
      if (this.settings) {
        if (this.settings.dateFormat === "DD-MMM-YYYY") {
          return "d-M-Y";
        } else if (this.settings.dateFormat === "DD/MM/YYYY") {
          return "d/m/Y";
        } else {
          return "m/d/Y";
        }
      } else {
        return "d-M-Y";
      }
    },
    formatTimeFlatPicker: function() {
      if (this.settings) {
        if (this.settings.timeFormat === "hh:mm A") {
          return {
            altFormat: "G:i K",
            dateFormat: "G:i K",
            time_24hr: false
          };
        } else {
          return {
            altFormat: "H:i",
            dateFormat: "H:i",
            time_24hr: true
          };
        }
      } else {
        return {
          altFormat: "G:i K",
          dateFormat: "G:i K",
          time_24hr: false
        };
      }
    }
  }
};
</script>
